import ContentCardLocalesTab from './ContentCardLocalesTab';

export default ContentCardLocalesTab;
